import { render } from "./QuickActions.vue?vue&type=template&id=638115fa&scoped=true"
import script from "./QuickActions.vue?vue&type=script&lang=js"
export * from "./QuickActions.vue?vue&type=script&lang=js"

import "./QuickActions.vue?vue&type=style&index=0&id=638115fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638115fa"]])

export default __exports__